module.exports = __webpack_public_path__ + "static/img/18.d88ffe1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/eng/18.png
// module id = oYNL
// module chunks = 0